import { z } from 'zod';
export const centsSchema = z
    .number()
    .int('Money must be whole cents — fractional cents are not representable')
    .nonnegative('Money cannot be negative')
    .max(100_000_000, 'Amount exceeds the R1,000,000 ceiling for a single job')
    .transform((n) => n);
export const cents = (n) => centsSchema.parse(n);
/** Build cents from rands. `rands(1450)` -> 145000 cents. */
export const rands = (r) => cents(Math.round(r * 100));
/** The platform's commission rate. Changing this is a business decision, not a code tweak. */
export const COMMISSION_RATE = 0.15;
export const ARTISAN_RATE = 0.85;
/**
 * Split a job's value 85/15.
 *
 * The artisan's share is rounded to the nearest cent and the commission takes the
 * remainder, so `artisan + commission === gross` always holds exactly. Deriving the
 * second number by subtraction rather than multiplication is what guarantees the
 * ledger balances — rounding both independently can lose or gain a cent.
 */
export function splitPayout(gross) {
    const artisan = Math.round(gross * ARTISAN_RATE);
    const commission = gross - artisan;
    return {
        gross,
        artisan: artisan,
        commission: commission,
    };
}
/**
 * Format cents for display in South African rand: 145000 -> "R1 450,00".
 *
 * Deliberately not `style: 'currency'` — that renders "R 1 450,00" with a space after
 * the R, which is not how the approved prototype or Handy Nest's existing customer
 * messages write it. The prototype is the visual specification, so the symbol is
 * prefixed manually and only the number is localised.
 *
 * The thousands separator is a non-breaking space (en-ZA convention), so a formatted
 * amount never wraps across a line break.
 */
export function formatCents(value) {
    const amount = new Intl.NumberFormat('en-ZA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value / 100);
    return `R${amount}`;
}
//# sourceMappingURL=money.js.map